import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  padding-left: 2px;\n'], ['\n  color: ', ';\n  padding-left: 2px;\n']);

/* eslint-disable no-console */ // While in dev preview console.info will be used
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { colors } from '@atlaskit/theme';
import styled from 'styled-components';
import './Form';
import FieldWrapper, { HelperText, Label } from './styled/Field';
import { ValidatorMessage } from './';

/**
 * The Field State exposed to the Form and other fields
 */


var RequiredIndicator = styled.span(_templateObject, colors.red);

// TODO: Decide & implement how multiple error messages should be displayed. Likely an UO list
var messageSeperator = ' ';

var Field = function (_Component) {
  _inherits(Field, _Component);

  function Field(props) {
    _classCallCheck(this, Field);

    var _this = _possibleConstructorReturn(this, (Field.__proto__ || _Object$getPrototypeOf(Field)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      fieldState: _this.getFieldStateFromProps(props),
      component: _this.getComponentFromProps(props)
    };
    // Register the field in the parent form if there is one
    if (props.form && _this.state.fieldState) props.form.registerField(_this.state.fieldState);
    return _this;
  }
  /** Register the field in the form if there is one */


  _createClass(Field, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}

    /** Handle prop or children prop changes */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        fieldState: this.getFieldStateFromProps(nextProps),
        component: this.getComponentFromProps(nextProps)
      });
    }

    /** Return the component from children or the component prop */


    /** Return the fieldState from Props */


    /**
     * Until we have a Form API we need to account for different onChange event types.
     * TODO: replace the hacks with a map of Field onChange event types
     */


    /**
     * Handle onChange for components that dispatch an input event.
     */


    /** Handle onChange for components that dispatch an input event.
     * Until we have a Form API we need to account for different event types
     */


    /**
     * Run any validators passed for this field
     */


    /** Render a label & make it required / not required. */


    /**
     * Render the field component passed as children and inject props from this field.
     * We always overide field components validation display.
     * TODO: audit all current field components to map others.
     */

  }, {
    key: 'render',


    /**
     * When we render Label, Helper & Validation are only handled only if passed as props. This allows for
     * components that currently roll their own to still be wrapped by Field.
     */
    value: function render() {
      var _state$fieldState = this.state.fieldState,
          helperText = _state$fieldState.helperText,
          isInvalid = _state$fieldState.isInvalid,
          invalidMessage = _state$fieldState.invalidMessage,
          validMessage = _state$fieldState.validMessage;


      return React.createElement(
        FieldWrapper,
        null,
        this.renderLabel(),
        this.renderFieldComponent(),
        helperText && helperText.length ? React.createElement(
          HelperText,
          null,
          helperText
        ) : null,
        React.createElement(ValidatorMessage, {
          isInvalid: isInvalid,
          validMessage: validMessage,
          invalidMessage: invalidMessage
        })
      );
    }
  }]);

  return Field;
}(Component);

Field.defaultProps = {
  validators: [],
  isInvalid: undefined,
  required: false,
  invalidMessage: '',
  validMessage: '',
  helperText: '',
  validateOnChange: false,
  validateOnBlur: true,
  validateOnInvalid: true
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getComponentFromProps = function (props) {
    // Field must have component passed in or a single child
    if (React.Children.only(props.children) && props.component) {
      console.warn('Field expects the component to be passed as a child OR component. Both have been passed and child is being used.');
    } else if (!React.Children.only(props.children) && !props.component) {
      console.warn('Field must have one valid child which is a field component. E.g FieldText, Select');
    }
    return React.Children.only(props.children) || props.component || {};
  };

  this.getFieldStateFromProps = function (props) {
    var id = props.id,
        name = props.name,
        label = props.label,
        validators = props.validators,
        isInvalid = props.isInvalid,
        invalidMessage = props.invalidMessage,
        validMessage = props.validMessage,
        required = props.required,
        helperText = props.helperText,
        validateOnChange = props.validateOnChange,
        validateOnBlur = props.validateOnBlur,
        validateOnInvalid = props.validateOnInvalid;

    var childComponent = _this2.getComponentFromProps(props);
    var fieldState = {
      validators: validators,
      isInvalid: isInvalid,
      invalidMessage: invalidMessage,
      validMessage: validMessage,
      isRequired: required,
      name: childComponent.props.name || name,
      id: childComponent.props.id || id || name,
      label: childComponent.props.label || label,
      value: childComponent.props.value || '',
      validate: _this2.validate,
      helperText: helperText,
      validateOnChange: validateOnChange,
      validateOnBlur: validateOnBlur,
      validateOnInvalid: validateOnInvalid,
      componentType: childComponent.props.componentType || childComponent.type.name
    };
    // For some components like Checkbox that are wrapped in withTheme and exported via anon function
    // we need to check for known props to idenitfy them. TODO: Fix this in the affected components and remove this hack
    if (!fieldState.componentType || !fieldState.componentType.length) {
      // Checkbox stateless
      if (childComponent.props.isChecked !== undefined) fieldState.componentType = 'CheckboxStateless';
    }
    return fieldState;
  };

  this.getValueFromEvent = function () {
    // Can we use
  };

  this.handleOnChange = function (event, meta) {
    var fieldState = _this2.state.fieldState;

    // Call any onChange defined for Field or the component.
    // This is required to support stateless components
    if (_this2.state.component.props && _this2.state.component.props.onChange) {
      _this2.state.component.props.onChange(event);
    }

    // TODO: review if we need to expose this? Might make more sense to just have an onUpdate which fires
    // when fieldState is updated
    if (_this2.props.onChange) {
      _this2.props.onChange(event, meta);
    }

    // TODO: move mapping event types to field components to json
    // Most Inputs - Event from HTMLInput | Event

    // Checkbox
    if (_this2.state.fieldState.componentType === 'Checkbox') {
      fieldState.value = event.isChecked ? event.value : '';

      // Stateless checkbox
    } else if (_this2.state.fieldState.componentType === 'CheckboxStateless') {
      fieldState.value = event.currentTarget.checked ? event.currentTarget.value : '';
      // Most Inputs - Event from HTMLInput | Event
    } else if (event && event.target) {
      fieldState.value = event.target.value || '';
      // Strings from inputs, objects & arrays of objects from select
    } else if (event) {
      fieldState.value = event;
      // Default to empty string
    } else {
      fieldState.value = '';
    }

    // Update Field State and pass on
    _this2.setState({ fieldState: fieldState });
    if (_this2.props.validateOnChange) {
      _this2.validate();
    }
  };

  this.handleOnBlur = function () {
    if (_this2.props.validateOnBlur) {
      _this2.validate();
    }
  };

  this.validate = function () {
    var _state$fieldState2 = _this2.state.fieldState,
        validators = _state$fieldState2.validators,
        value = _state$fieldState2.value;

    var _state$fieldState3 = _this2.state.fieldState,
        isInvalid = _state$fieldState3.isInvalid,
        invalidMessage = _state$fieldState3.invalidMessage,
        validMessage = _state$fieldState3.validMessage,
        required = _state$fieldState3.required,
        rest = _objectWithoutProperties(_state$fieldState3, ['isInvalid', 'invalidMessage', 'validMessage', 'required']);

    var result = true;
    var invalid = '';
    var valid = '';
    var invalidCount = 0;

    // Is the field required?
    if (required && !value) {
      invalidCount++;
      invalid = 'This field is required';
    } else if (validators && validators.length) {
      for (var i = 0; i < validators.length; i++) {
        if (validators[i].props.func) {
          result = validators[i].props.func(value, validators[i].props.options);

          // Invert result if validOn prop is false
          if (validators[i].props.validOnFalse) result = !result;

          // Most validators will only have an invalid message
          if (result) {
            valid = valid.concat(validators[i].props.valid + messageSeperator);
          } else {
            invalidCount++;
            invalid = invalid.concat(validators[i].props.invalid + messageSeperator);
          }
        }
      }
    }

    _this2.setState({
      fieldState: _extends({
        isInvalid: !!invalidCount,
        invalidMessage: invalid,
        validMessage: valid
      }, rest)
    });
  };

  this.renderLabel = function () {
    if (_this2.props.label && _this2.props.label.length) {
      return React.createElement(
        Label,
        { htmlFor: _this2.props.id },
        _this2.props.label,
        _this2.props.isRequired ? React.createElement(
          RequiredIndicator,
          { role: 'presentation' },
          '*'
        ) : null
      );
    }
    return null;
  };

  this.renderFieldComponent = function () {
    var _state$fieldState4 = _this2.state.fieldState,
        id = _state$fieldState4.id,
        name = _state$fieldState4.name,
        isInvalid = _state$fieldState4.isInvalid,
        required = _state$fieldState4.required,
        label = _state$fieldState4.label,
        invalidMessage = _state$fieldState4.invalidMessage;

    var component = _this2.state.component;
    var validationState = 'default';

    if (component) {
      // validationState & validationMessage are used to support AtlaskitSelect dev preview
      if (isInvalid !== undefined) {
        validationState = isInvalid ? 'error' : 'success';
      }
      return React.cloneElement(component, {
        id: id,
        name: name,
        isInvalid: isInvalid,
        isRequired: required,
        label: label,
        invalidMessage: invalidMessage,
        isLabelHidden: true,
        isValidationHidden: true,
        validationMessage: invalidMessage,
        validationState: validationState,
        onChange: _this2.handleOnChange,
        onUpdate: _this2.handleOnChange,
        onBlur: _this2.handleOnBlur
      });
    }
    return null;
  };
};

export default Field;